export default __webpack_public_path__ + "static/media/homeparticles.b59ec38c.png";